import axios from "axios";
export const axiosInstance = axios.create();


axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const originalRequest = error.config;
    // Error
    const {
      response: { status },
    } = error;

    if (status === 403) {
      // Unauthorized request: maybe access token has expired!
      return refreshAccessToken(originalRequest);
    } else {
      return Promise.reject(error);
    }
  }
);

const refreshAccessToken = async (_originalRequest) => {
   try {
     const newToken = await getToken();
     _originalRequest.headers.Authorization = newToken; 
     return axios(_originalRequest);
   } catch (error) {
     console.log(error);
   }
};

const getToken = () => {
  try {
    const uid = localStorage.getItem("uid-r");
    return axios.get(
      `${process.env.CATEGORY_API_URL}/comfama/tokenizer/api/v1/accessToken?uid=${uid}`
    ).then(data => {
      if (data.status === 200) {
        return data.data.data.accessToken;
      }
    })
    // console.log("New access token", data)
  } catch (error) {
    console.log(error);
  }
};
